import { DashboardView } from 'src/app/services/query-context/models/dashboard-view.model';

/**
 * Helper class for SavedDashboardView
 */
export class SavedDashboardViewHelper {
    /**
     * Sorts the dashboard views by name alphabetically
     * @param [sortOrder='asc'] - sort order `asc` or `desc`
     */
    static compareDashboardViewsByName(
        a: DashboardView,
        b: DashboardView,
        sortOrder: 'asc' | 'desc' = 'asc'
    ): number {
        if (a.name === undefined || b.name === undefined) {
            throw new Error('DashboardView name is undefined');
        }
        if (a.name === b.name) {
            return 0;
        }
        if (sortOrder === 'asc') {
            return a.name < b.name ? -1 : 1;
        } else {
            return a.name < b.name ? 1 : -1;
        }
    }
}
